import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useReviewStatusDashboardStyles = makeStyles({
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: designTokens.spacing[4],
    "@media (max-width: 640px)": {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    "@media (max-width: 480px)": {
      gridTemplateColumns: "1fr",
    },
  },
});
